import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import {
  VARIABLE_TONE_PALETTES,
  type VariableTone,
} from '@/theme/buttonTokens';

/**
 * 의견입력 결재/반려/보류 모달 본문·푸터 styled.
 * 에디터 셸/카운터는 참조인추가(AddReferrerModal)의 EditorShell/CharCount 패턴과 동일.
 */

export const OpinionNotice = styled('p')`
  margin: 0 0 8px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--dk-text-strong, #637381);
`;

/** 리치 에디터 셸 — 글자수 카운터 우하단 오버레이. 참조인추가 EditorShell 과 동일 구조. */
export const EditorShell = styled(Box)(() => ({
  position: 'relative',
  '& .editor-shell .editor-scroller': { minHeight: 200 },
}));

/** 우하단 글자수 카운터 */
export const CharCount = styled('span')(({ theme }) => ({
  position: 'absolute',
  right: 12,
  bottom: 10,
  padding: '0 4px',
  background: theme.palette.common.white,
  fontSize: 12,
  lineHeight: '16px',
  color: theme.palette.text.disabled,
  pointerEvents: 'none',
}));

export const OpinionFooter = styled('div')`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
`;

/** 결재/반려/보류 버튼 */
export const DecisionButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'tone',
})<{ tone: VariableTone }>(({ tone }) => {
  const c = VARIABLE_TONE_PALETTES[tone];
  return {
    // .btn 베이스
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
    border: 'none',
    cursor: 'pointer',
    fontFamily: 'Pretendard, sans-serif',
    fontWeight: 400,
    whiteSpace: 'nowrap',
    flexShrink: 0,
    // 가이드 Small (height 36): padding 8 / gap 4 / min-width 64 / font 12·16 / icon 16
    padding: 8,
    gap: 4,
    minWidth: 64,
    fontSize: 12,
    lineHeight: '16px',
    '& .btn__label': { padding: '0 4px' },
    '& svg': { width: 14, height: 14, flexShrink: 0, display: 'block' },
    background: c.enabled,
    color: '#fff',
    '&:hover': { background: c.hover },
    '&:active': { background: c.pressed },
    '&:disabled': {
      background: 'var(--dk-bg-strong, #D1D8E2)',
      color: '#fff',
      cursor: 'default',
      pointerEvents: 'none',
    },
  };
});
